// @flow

import styled from 'styled-components';

export default styled.div`
  padding-left: 8px;
  padding-right: 8px;
`;
